export const caseStudiesBannerData = {
  title: 'Case Studies',
};
